
import React, { useState, useEffect } from 'react';
import tapIcon from '../../../services/TapIcon';
import Ax from "../../../components/hoc/Ax";
import { connect, useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import AppBaseComponent from "../../../components/AppBaseComponent";
import HttpAPICall from "../../../services/HttpAPICall";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import TapApiUrls, { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';
import TapSelect from '../../../components/ui/TapSelect';

const ModelAdd = ({ history, location }) => {
    const initAddModelForm = {
        name: '',
        manufacturer_id: '',
        notes: ''
    };
    const modelUrl                  =       BACKOFFICE_BASE_URL + '/model'
    
    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);
    const [addModelForm, setAddModelForm] = useState(initAddModelForm);
    const [formLoading, setFormLoading] = useState(false);
    const [editResource, setEditResource] = useState(false);
    const [manufacturers, setManufacturers] = useState([]);
    const access_token = useSelector(state => state.auth.access_token);
    useEffect(() => {
        getAddFormData()
    }, []);

    const closeEvent = () => {
        history.push({ pathname: `/model_list` });
    };
    const getAddFormData = () => {
        setFormLoading(true);
        HttpAPICall.withAthorization('GET', modelUrl + '/form_data', access_token, {}, {}, (resp) => {
                let respData = resp.data.manufacturers;

                setManufacturers(respData.map(m => ({value : m.id, label: m.manufacturer})));
                if (location.state && location.state.editModelData) {
                    let detail = location.state.editModelData;
                    console.log(detail);
                    
                    setAddModelForm(pre => ({...pre,
                        id: detail.id,
                        name: detail.model,
                        manufacturer_id: detail.manufacturer.id,
                        notes: detail.description ? detail.description : "",
                    }));
                    setEditResource(true);
                }
                setFormLoading(false);
            }
        );
    };
    const tapSelectChange = (selectedOption, formKey) => {
        if (formKey) {
            const newValue = Array.isArray(selectedOption)
                ? selectedOption.length > 0 ? selectedOption.map(o => o.value) : []
                : selectedOption ? selectedOption.value : '';

            setAddModelForm(prevState => ({ ...prevState, [formKey]: newValue }));
        }
    };
    const submitAddModelForm = (e) => {
        e.preventDefault();
        const formData = {
            ...addModelForm,
        };
        if (editResource) {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('PUT', modelUrl + '/edit', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                setAddModelForm({ ...initAddModelForm });
                history.push({ pathname: `/model_list` })
            }).then(() => setSaveFormSubmitting(false));
        } else {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('POST', modelUrl + '/add', access_token, {}, { ...formData }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                setAddModelForm({ ...initAddModelForm });
                history.push({ pathname: `/model_list` })
            }).then(() => setSaveFormSubmitting(false));
        }

    };

    const formInputHandler = (e, formName) => {
        const { name, value } = e.target;
        if (formName === "addModelForm") {
            setAddModelForm(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const saveModelFormJsx = () => {
        return (
            <form className="bg-white p-3" onSubmit={submitAddModelForm} id="saveResourceForm">
                {formLoading ? <Loader />
                    : <Ax>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="name" className="form-label require">Name</label>
                            </div>
                            <div className="col-sm-4 ">
                                <input
                                    name="name"
                                    type="text"
                                    value={addModelForm.name}
                                    className="form-control"
                                    autoComplete="off"
                                    required={true}
                                    onChange={(e) => formInputHandler(e, "addModelForm")}
                                    placeholder="Please enter Name"
                                />
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="manufacturer" className="form-label">Manufacturer</label>
                            </div>
                            <div className="col-sm-4 ">
                            <TapSelect
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'manufacturer_id')}
                                options={manufacturers}
                                isSearchable={true}
                                isClearable={true}
                                required={true}
                                value={manufacturers.find(s => addModelForm.manufacturer_id === s.value) || null}
                                placeholder={"Please Select Manufacturer"}
                            />
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="notes" className="form-label require">Notes</label>
                            </div>
                            <div className="col-sm-4 add_calender_section">
                                <textarea
                                    name="notes"
                                    value={addModelForm.notes}
                                    onChange={(e) => formInputHandler(e, 'addModelForm')}
                                    className="form-control"
                                    style={{ height: "100px" }}
                                    required={true}
                                />
                            </div>
                        </div>
                    </Ax>}
                <div className="col-12 text-end fixed_footer">
                    <button type="button" disabled={saveFormSubmitting} onClick={closeEvent} className="btn btn-secondary mx-3">Cancel</button>
                    <button type="submit" disabled={saveFormSubmitting} className="btn btn-primary mx-2">
                        Save {saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </div>
            </form>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Model Add</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>{editResource ? "Edit" : "Add"} Model</h3>
                    <div className="text-end mt15">
                        <button onClick={closeEvent} disabled={saveFormSubmitting} type="button" className="btn btn-secondary">
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Fuel Station" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        {saveModelFormJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};


export default ModelAdd;
